import { motion } from 'framer-motion'
import React from 'react'

type OpacityAnimationProps = {
  key?: string
  className?: string
  duration?: number
  pending?: boolean
}

const OpacityAnimation: React.FC<
  React.PropsWithChildren<OpacityAnimationProps>
> = ({ children, key, className, duration = 0.5, pending }) => {
  return (
    <motion.div
      key={key}
      className={className}
      initial={{ opacity: pending ? 1 : 0 }}
      animate={{
        opacity: pending ? 0 : 1
      }}
      exit={{ opacity: pending ? 1 : 0 }}
      transition={{ ease: 'easeOut', duration }}
    >
      {children}
    </motion.div>
  )
}

export default OpacityAnimation
